import type { ControlPlaneCapability } from '@internal/spassu-code-contract';
import { Button } from '@material-ui/core';

/**
 * Renders nothing for a denied capability (RN-CONEX-01). The server decides
 * `allowed`; the page shows only what the reader can actually do, so a denied
 * action never appears, not even disabled. Pairing material is only ever
 * produced by the owner's own mutation response and is never persisted here.
 */
export function CapabilityButton(props: {
  capability: ControlPlaneCapability;
  label: string;
  busy: boolean;
  variant?: 'contained' | 'outlined' | 'text';
  color?: 'primary' | 'secondary' | 'default';
  onClick(): void;
}) {
  if (!props.capability.allowed) return null;
  return (
    <Button
      variant={props.variant ?? 'outlined'}
      color={props.color ?? 'primary'}
      onClick={props.onClick}
      disabled={props.busy}
    >
      {props.label}
    </Button>
  );
}
